"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SESSION_KEY = 'ic-session';
exports.PERMISSIONS = {
    canSeeAppointments: 'can_see_appointments',
    canChangeAppointmentsFilters: 'can_change_appointments_filters',
    canSeeCars: 'can_see_cars',
    canCreateCarMake: 'can_create_car_make',
    canCreateCarVersion: 'can_create_car_version',
    canEditCarVersion: 'can_edit_car_version',
    canRemoveCarVersion: 'can_remove_car_version',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2NvbnN0YW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFhLFFBQUEsV0FBVyxHQUFHLFlBQVksQ0FBQztBQUUzQixRQUFBLFdBQVcsR0FBRztJQUN6QixrQkFBa0IsRUFBRSxzQkFBc0I7SUFDMUMsNEJBQTRCLEVBQUUsaUNBQWlDO0lBQy9ELFVBQVUsRUFBRSxjQUFjO0lBQzFCLGdCQUFnQixFQUFFLHFCQUFxQjtJQUN2QyxtQkFBbUIsRUFBRSx3QkFBd0I7SUFDN0MsaUJBQWlCLEVBQUUsc0JBQXNCO0lBQ3pDLG1CQUFtQixFQUFFLHdCQUF3QjtDQUM5QyxDQUFDIn0=


//////////////////
// WEBPACK FOOTER
// ../@core/dist/constants.js
// module id = 166
// module chunks = 0